import React, {useCallback} from 'react'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {Spacer} from '../../../../Common/Components/Spacer'
import {MBContentBodyItemWarningMessageTypography} from '../../Atoms/Typographies'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {LinkIconText} from '../../Molecules/LinkIconText'
import dayjs from 'dayjs'


type CompleteMessageContentProps = {
  title: string
  topMessage: string
  nextContractStartDate?: string
  onCvsSelectLinkClick?: () => void
}

export const CompleteMessageContent: React.VFC<CompleteMessageContentProps> = (
  {
    title,
    topMessage,
    nextContractStartDate,
    onCvsSelectLinkClick,
  },
) => {
  const handleCvsSelectLinkClick = useCallback((): void => {
    if (onCvsSelectLinkClick) onCvsSelectLinkClick()
  }, [onCvsSelectLinkClick])

  return (
    <ContentBlock data-testid={'block-notification'}>
      <ContentTitle>{`${title}変更完了`}</ContentTitle>
      <ContentTopMessage>
        {`${topMessage}の変更が完了しました。`}<br/>
        {'ご登録されているメールアドレスに完了通知を送信しました。'}
      </ContentTopMessage>

      {isLastMonthOfNextContractStartDate(nextContractStartDate) &&
      <Spacer my={'10px'}>
        <PIMStack spacing={'15px'} testId={'cvs-select-message'}>
          <MBContentBodyItemWarningMessageTypography>
            引き続き、以下のLinkよりお支払いのコンビニを選択し、支払い番号を払い出してください。
          </MBContentBodyItemWarningMessageTypography>
          <LinkIconText onClick={handleCvsSelectLinkClick}>
            お支払いのコンビニを選択する
          </LinkIconText>
        </PIMStack>
      </Spacer>
      }
    </ContentBlock>
  )
}

const isLastMonthOfNextContractStartDate = (nextContractStartDate_YYYYMMDD?: string): boolean => {
  if (!nextContractStartDate_YYYYMMDD) return false

  const format_YYYYMM = 'YYYY/MM'

  const now = dayjs().format(format_YYYYMM)

  const lastMonthOfNextStartDate = dayjs(nextContractStartDate_YYYYMMDD).subtract(1, 'month')
  const nextStartDate = dayjs(lastMonthOfNextStartDate).format(format_YYYYMM)

  return now === nextStartDate
}
